import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */
import { useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import { BANNER, BANNER_HEIGHT, DEFAULT_BANNER_HEIGHT, LEFT_PANEL_WIDTH, RIGHT_PANEL_WIDTH, VAR_BANNER_HEIGHT } from '../../common/constants';
import { getPageLayoutSlotSelector, resolveDimension } from '../../common/utils';
import { publishGridState, useSkipLink } from '../../controllers';
import SlotFocusRing from './internal/slot-focus-ring';
import SlotDimensions from './slot-dimensions';
var bannerStyles = css({
  height: BANNER_HEIGHT,
  gridArea: BANNER
});
var bannerFixedStyles = css({
  position: 'fixed',
  zIndex: 2,
  top: 0,
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  right: RIGHT_PANEL_WIDTH,
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  left: LEFT_PANEL_WIDTH
});

/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */
var Banner = function Banner(props) {
  var children = props.children,
    _props$height = props.height,
    height = _props$height === void 0 ? DEFAULT_BANNER_HEIGHT : _props$height,
    _props$isFixed = props.isFixed,
    isFixed = _props$isFixed === void 0 ? true : _props$isFixed,
    shouldPersistHeight = props.shouldPersistHeight,
    testId = props.testId,
    skipLinkTitle = props.skipLinkTitle,
    id = props.id;
  var bannerHeight = resolveDimension(VAR_BANNER_HEIGHT, height, shouldPersistHeight);
  useEffect(function () {
    publishGridState(_defineProperty({}, VAR_BANNER_HEIGHT, bannerHeight));
    return function () {
      publishGridState(_defineProperty({}, VAR_BANNER_HEIGHT, 0));
    };
  }, [bannerHeight]);
  useSkipLink(id, skipLinkTitle);
  return jsx(SlotFocusRing, null, function (_ref) {
    var className = _ref.className;
    return jsx("div", _extends({
      css: [bannerStyles, isFixed && bannerFixedStyles],
      className: className,
      "data-testid": testId,
      id: id
    }, getPageLayoutSlotSelector('banner')), jsx(SlotDimensions, {
      variableName: VAR_BANNER_HEIGHT,
      value: bannerHeight
    }), children);
  });
};
export default Banner;